import * as React from "react";
import { useEffect, useState } from "react";
import { IsMobileDevice } from "source/app/domain/Device/Helpers/IsMobile";
import { OrchestrateEffects } from "source/app/presentation/MainPanel/Log/LogInputForm/Helpers/OrchestrateEffects";
import { LogInputEntryText } from "source/app/presentation/MainPanel/Log/LogInputForm/LogInputEntryText/LogInputEntryText";
import { State } from "source/app/services/UI/State/State";
import VerbConstants from "motw_core/Constants/VerbConstants";
import { AddNewEntry } from "../../../../services/Log/AddEntry";
import IconWithText from "../../../../services/Shared/IconWithText/IconWithText";
import { desktopBackgroundImages } from "../../../../services/UI/Background/DesktopImage/DesktopImage";
import { ESharedComponent } from "../../../../services/UI/State/ESharedComponent";
import { FormInput } from "../../../Shared/Form/Input/FormInput";
import { FormSelect } from "../../../Shared/Form/Select/FormSelect";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Render from "../../../Shared/Render";
import { StyleClass } from "../../../Shared/Styles/CSS";
import { ILogState } from "../ILogState";
import { SignificanceSelector } from "./EntrySignificance/LogInputEntrySignificance";
import { FilterGoalCardsSwitch } from "./FilterGoalCardsSwitch/FilterGoalCardsSwitch";
import { HandleAddLogEntryChange } from "./LogInputFormHelpers";
import Background from "source/app/services/UI/Background/Background";

export class LogInputForm extends React.PureComponent<
    ILogInputFormProps,
    ILogInputFormState
> {
    constructor(props: ILogInputFormProps) {
        super(props);
        this.state = defaultLogInputFormState;
    }

    async componentDidMount() {
        State.ShareClass(ESharedComponent.LogInputForm, this);
    }

    async componentDidUpdate() {
        const shouldOrchestrateEffects =
            this.props.logState.LogInpEntryText !== "" &&
            !this.state.isOrchestrationRunning;

        if (shouldOrchestrateEffects) {
            OrchestrateEffects();
        }

        State.ShareClass(ESharedComponent.LogInputForm, this);
    }

    render() {
        return (
            <div className="form-inline Log_InputForm">
                <div className="form-group" style={{ width: "100%" }}>
                    <FormSelect
                        id="inpVerb"
                        width={this.state.filterGoalCards ? "0px" : "100px"}
                        value={this.props.logState.inpVerb}
                        classes={StyleClass(
                            `dynamicPadding_${this.state.filterGoalCards}`,
                            {
                                padding: this.state.filterGoalCards
                                    ? `0px !important`
                                    : `6px 12px !important`,
                            }
                        )}
                        suggestions={VerbConstants.Verbs.Active()}
                        onChange={(event) =>
                            HandleAddLogEntryChange(
                                "inpVerb",
                                event.target.value
                            )
                        }
                        onFocus={() => OnLogInputFormControlFocus()}
                        onDefocus={() => Defocus()}
                        dynamicOpacity
                    />
                    <LogInputEntryText logInputForm={this} />
                    <Render
                        id="additionalLogEntryControls"
                        when={
                            this.props.logState.LogInpEntryText &&
                            !this.state.filterGoalCards
                        }
                    >
                        <SignificanceSelector
                            significance={this.props.logState.inpSignificance}
                            onDefocus={() => Defocus()}
                        />
                        <FormInput
                            id="inpKips"
                            width="60px"
                            type="number"
                            placeholder="₭"
                            pattern="[0-9]*"
                            value={this.props.logState.inpKips}
                            onChange={(event) =>
                                HandleAddLogEntryChange(
                                    "inpKips",
                                    event.target.value
                                )
                            }
                            onEnter={() => AddNewEntry(this.props.logState)}
                            onFocus={() => OnLogInputFormControlFocus()}
                            onDefocus={() => Defocus()}
                            dynamicOpacity
                        />
                    </Render>
                    <SubmitLink logState={this.props.logState} />
                    <FilterGoalCardsSwitch
                        isChecked={this.state.filterGoalCards}
                        setIsChecked={(value) =>
                            this.setState({ filterGoalCards: value })
                        }
                    />
                </div>
            </div>
        );
    }
}

export const defaultLogInputFormState: ILogInputFormState = {
    filterGoalCards: false,
    isOrchestrationRunning: false,
};

export interface ILogInputFormProps {
    logState: ILogState;
}

export interface ILogInputFormState {
    filterGoalCards: boolean;
    isOrchestrationRunning: boolean;
}

export function GetIsFilteringGoalCards() {
    return State.ReadClass<ILogInputFormState>(ESharedComponent.LogInputForm)
        ?.state.filterGoalCards;
}

/**
 * Check if the "Filter Goal Cards" switch is enabled on the Log Input Form options
 * (as opposed to a non-goal-card log entry)
 */
export const IsFilterGoalCardsSwitchEnabled = () => {
    const logInputForm = State.ReadClass<ILogInputFormState>(
        ESharedComponent.LogInputForm
    );

    const filterGoalCards = logInputForm
        ? logInputForm.state.filterGoalCards
        : false;

    return filterGoalCards;
};

export const Defocus = () => {
    Background.ChangeImage();
};

const SubmitLink = ({ logState }: { logState: ILogState }) => {
    const [isVisible, setIsVisible] = useState(false);

    const shouldDisplay =
        logState.LogInpEntryText !== "" &&
        Number.parseInt(logState.inpKips) > 0;

    useEffect(() => {
        setIsVisible(shouldDisplay);
    }, [shouldDisplay]);

    return (
        <Render id="submitLogEntryButton" when={isVisible}>
            <IconWithText
                iconSuffix={EGlyphicon.ok}
                whenClicked={async () => AddNewEntry(logState)}
                displayAsBlock={true}
                withClass={StyleClass(`filterGoalCardSwitch`, {
                    marginTop: `15px`,
                })}
            >
                Submit
            </IconWithText>
        </Render>
    );
};

export const OnLogInputFormControlFocus = () => {
    const logInputForm = State.ReadClass<ILogInputFormState>(
        ESharedComponent.LogInputForm
    );

    if (IsMobileDevice()) {
        desktopBackgroundImages.transcendent.Show();
    }
};
